import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    TrackAiAssistantConversation as TrackAiAssistantConversationMutation,
    TrackAiAssistantConversationVariables,
    AiAssistantConversation,
} from 'nutshell-graphql-types';

import TRACK_AI_ASSISTANT_CONVERSATION from '../mutations/track-ai-assistant-conversation.graphql';

export const useTrackAiAssistantConversation = (): {
    trackAiAssistantConversation: (arg1: AiAssistantConversation) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [trackAiAssistantConversation, {loading, error}] = useMutation<
        TrackAiAssistantConversationMutation,
        TrackAiAssistantConversationVariables
    >(TRACK_AI_ASSISTANT_CONVERSATION);

    return {
        trackAiAssistantConversation: (input: AiAssistantConversation) =>
            trackAiAssistantConversation({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
